import { EventService } from '../services/eventService';
import { PreferenceService } from '../services/preferenceService';
import ModalState from './modalState';

/**
 * Runs side-effects related to modal state changes.
 */
export const runModalStateChangeEffect = (
  eventService: EventService,
  modalState: ModalState,
  lastModalState: ModalState | null
): void => {
  // No modal state change; return early.
  if (modalState === lastModalState) {
    return;
  }

  // Event: Pop-up opened (state went from `NONE` to not `NONE`).
  // Note that `null` is not considered an old state of `NONE`.
  if (lastModalState === ModalState.NONE) {
    eventService.sendPopUpOpenedEvent();
  }

  // Event: Form page opened (user was exposed to a form page).
  if (modalState === ModalState.ADD_EMAIL_FORM || modalState === ModalState.CHANGE_PASSWORD_FORM) {
    eventService.sendFormOpenedEvent();
  }

  // Event: A modal state was viewed (should capture the initial `NONE` state on page load).
  eventService.sendModalStateViewedEvent(modalState);
};

/**
 * Runs side-effects related to prompt dismiss actions.
 */
export const runPromptDismissEffect = (
  eventService: EventService,
  preferenceService: PreferenceService,
  wasPromptDismissedTemporary: boolean,
  wasPromptDismissedForever: boolean
): void => {
  if (wasPromptDismissedTemporary) {
    preferenceService.dismissPrompt(false);
    // Event: Pop-up dismissed (temporary).
    eventService.sendPromptDismissedEvent(false);
  } else if (wasPromptDismissedForever) {
    preferenceService.dismissPrompt(true);
    // Event: Pop-up dismissed (forever).
    eventService.sendPromptDismissedEvent(true);
  }
};
